import React, { useState, useEffect } from "react";
import { View, StyleSheet, Platform } from "react-native";

import { capitalize } from "lodash";

import { getContactMailUrl, openURL } from "../../../../helpers/utils";

import Animation from "../../animation/LotieView";
import { buttonStyle } from "../../common/ActionsMenuButton/utils";

import ActionButton from "../../common/ActionsMenuButton/ActionButton";
import AddGoalIcon from "../../common/ActionsMenuButton/icons/AddGoalIcon";
import AppTheme from "../../AppTheme";
import RoutinesIcon from "../../common/icons/RoutinesIcon";
import InviteIcon from "../../common/ActionsMenuButton/icons/InviteIcon";
import NewElementIcon from "../../common/ActionsMenuButton/icons/NewElementIcon";
import ReportsIcon from "../../common/ActionsMenuButton/icons/ReportsIcon";
import Icons from "../../common/icons";

export default function EditReflectionFabButton({
  showManaMindful = false,
  mariMessage = "",
  editElement = () => {},
  addNewGoal = () => {},
  createNewReport = null,
  timeUnit,
  createNewRoutine,
  style = {},
  mariOptions = {},
  showLineChart = false,
  toggleChartMenu = () => {},
}) {
  const [actionButton, setActionButton] = useState(null);
  const [animation, setAnimation] = useState(null);

  const actions = [
    <ActionButton.Item
      key={1}
      underline
      buttonColor="#FFF"
      title="Help"
      onPress={() => {
        openURL(getContactMailUrl());
      }}
    >
      <InviteIcon />
    </ActionButton.Item>,

    <ActionButton.Item
        key={2}
        underline
        buttonColor="#FFF"
        title={showLineChart ? "Bar Graph Mode" : "Line Graph Mode"}
        onPress={() => {
          toggleChartMenu(showLineChart ? "Bar Graph Mode" : "Line Graph Mode");
        }}
    >
      <Icons.BarChartSwitchViewIcon showLineChart={showLineChart} fill={"#239C9D"} />
    </ActionButton.Item>,

    <ActionButton.Item
      key={3}
      hideShadow
      buttonColor="#FFF"
      title="New Goal"
      onPress={addNewGoal}
    >
      <AddGoalIcon />
    </ActionButton.Item>,

    {/* <ActionButton.Item
      key={3}
      hideShadow
      buttonColor="#FFF"
      title="Edit Element"
      onPress={editElement}
    >
      <NewElementIcon />
    </ActionButton.Item>, */}
  ];

  if (createNewRoutine) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={4}
        buttonColor="#FFF"
        title={`Create ${capitalize(timeUnit)} Routine`}
        onPress={createNewRoutine}
      >
        <RoutinesIcon />
      </ActionButton.Item>,
    );
  }

  if (createNewReport) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={5}
        buttonColor="#FFF"
        title="Create Report"
        onPress={createNewReport}
      >
        <ReportsIcon />
      </ActionButton.Item>,
    );
  }

  useEffect(() => {
    if (animation) animation.play();
  }, [animation]);

  return (
    <View
      style={[buttonStyle, style]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      {showManaMindful ? (
        <Animation
          ref={(ref) => {
            setAnimation(ref);
          }}
          style={{
            width: 107,
            height: 110,
          }}
          source={require("../../../../assets/animations/mana-mindful.json")}
          loop={true}
          autoplay={true}
        />
      ) : (
        <ActionButton
          mariOptions={mariOptions}
          ref={(r) => setActionButton(r)}
          buttonColor={AppTheme.DEFAULT_COLOR}
          zIndex={999}
          source={"EditReflectionFabButton"}
          buttonTextStyle={styles.mainButton}
          mariMessage={mariMessage}
        >
          {actions}
        </ActionButton>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  mainButton: {
    fontSize: 44,
    height: 58,
    marginTop: -5,
    fontWeight: "200",
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }),
  },
  actionButtonIcon: {
    marginTop: 5,
    width: 44,
    height: 44,
  },
});
